// Polyfill: AWS Chime SDK references `global` (Node.js) which doesn't exist in browsers
(window as unknown as { global: Window }).global = window;

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
